import { ConvertStringToHtmlId } from '../../../../../libs/ts/ConvertStringToHtmlId';
import type { ReactElement } from 'react';

export interface props<T> {
  title: string;
  data: T[] | undefined;
  className?: string;
  children: ReactElement[];
}

export const List = function <T>(props: props<T>) {
  return (
    <div className={`jbp-list-${ConvertStringToHtmlId(props.title)} mt-2 overflow-y-scroll pr-2 ${props.className}`} data-length={props.data == undefined ? 0 : props.data.length}>
      {props.children}
    </div>
  );
};
